<template>
  <div class="track-redirect">
    <i class="el-icon-loading loading-spinner"></i>
  </div>
</template>

<script>
import { trackEvent } from "@/utils/track";

const DEFAULT_EVENT_CODE = "PP_TRACK_REDIRECT";

function decodeBase64(str) {
  if (!str) return "";
  // URL-safe base64: 将 _ 替换为 /，- 替换为 +，再补齐 padding
  let base64 = str.replace(/_/g, "/").replace(/-/g, "+");
  while (base64.length % 4 !== 0) {
    base64 += "=";
  }
  try {
    return decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
  } catch (e) {
    // fallback: 直接 atob（纯 ASCII 内容）
    return atob(base64);
  }
}

function parseJson(text, fallback = {}) {
  if (!text) {
    return fallback;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    console.error("[track-redirect] invalid json payload", error);
    return fallback;
  }
}

export default {
  name: "TrackRedirect",
  async created() {

    const query = this.$route.query || {};
    const targetUrl = query.url || query.targetUrl || "";
    const eventCode = query.eventCode || DEFAULT_EVENT_CODE;
    const pageTitle = query.pageTitle !== undefined ? query.pageTitle : "";
    const rawProperties = query.properties || "";
    const properties = parseJson(
      rawProperties.startsWith("{") ? rawProperties : decodeBase64(rawProperties),
      {}
    );

    if (!targetUrl) {
      this.$message && this.$message.error("缺少跳转地址");
      return;
    }

    try {
      await trackEvent({
        eventCode,
        pageTitle,
        properties,
        pageUrl: targetUrl,
      });
      window.location.replace(targetUrl);
    } catch (error) {
      console.error("[track-redirect] trackEvent failed", error);
      // 有服务端响应结果(例如 4xx/5xx)也允许继续跳转
      if (error && error.response) {
        window.location.replace(targetUrl);
        return;
      }

      this.$message && this.$message.error("埋点请求未返回，已取消跳转");
    }
  },
};
</script>

<style scoped>
.track-redirect {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  font-size: 36px;
  color: #409eff;
}
</style>
